var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      ref: "vspopup-lesson",
      attrs: {
        title: _vm.$t("lesson.titles"),
        active: _vm.visible,
        id: "popup-lesson",
      },
      on: {
        "update:active": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closePopup,
      },
    },
    [
      _vm.plan.classes_per_period
        ? _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "p-1 mb-0",
                  attrs: { show: "", variant: "info" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-start" },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-1 flex-shrink-0",
                        attrs: { icon: "InfoIcon" },
                      }),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("subscription_plan.candidates_help", {
                              quota: _vm.plan.classes_per_period,
                              period: (
                                _vm.plan.quota_period_label || ""
                              ).toLowerCase(),
                            })
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-input-group",
        { staticClass: "mb-2" },
        [
          _c(
            "b-input-group-prepend",
            { attrs: { "is-text": "" } },
            [
              _c("feather-icon", {
                staticClass: "h-4 w-4",
                attrs: { icon: "SearchIcon" },
              }),
            ],
            1
          ),
          _c("b-form-input", {
            attrs: { placeholder: "Pesquisar", debounce: "400" },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.reload(true)
              },
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c("b-table", {
        attrs: {
          items: _vm.rows,
          fields: _vm.fields,
          busy: _vm.loading,
          small: "",
          responsive: "",
          striped: "",
          "show-empty": "",
          "empty-text": _vm.$t("subscription_plan.no_lesson_candidates"),
        },
        scopedSlots: _vm._u([
          {
            key: "cell(selected)",
            fn: function (row) {
              return [
                _c("b-form-checkbox", {
                  attrs: { checked: _vm.isSelected(row.item.id) },
                  on: {
                    change: function ($event) {
                      return _vm.toggle(row.item)
                    },
                  },
                }),
              ]
            },
          },
          {
            key: "cell(name)",
            fn: function (row) {
              return [
                _c("div", { staticClass: "font-medium" }, [
                  _vm._v(_vm._s(row.item.name)),
                ]),
                !row.item.meets_plan
                  ? _c(
                      "small",
                      { staticClass: "text-warning d-block" },
                      [
                        _c("feather-icon", {
                          staticClass: "h-3 w-3",
                          attrs: { icon: "AlertTriangleIcon" },
                        }),
                        _vm._v(" " + _vm._s(row.item.reason) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(schedules_count)",
            fn: function (row) {
              return [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("subscription_plan.weekly_slots", {
                        count: row.item.schedules_count,
                      })
                    )
                  ),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("subscription_plan.offers_in_period", {
                          count: row.item.offered_in_period,
                        })
                      ) +
                      " "
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm.selected.length && _vm.required
        ? _c("div", { staticClass: "border rounded p-1 mt-1 mb-1" }, [
            _c(
              "small",
              {
                class:
                  _vm.offeredTotal >= _vm.required
                    ? "text-success"
                    : "text-warning",
              },
              [
                _c("feather-icon", {
                  staticClass: "h-4 w-4",
                  attrs: {
                    icon:
                      _vm.offeredTotal >= _vm.required
                        ? "CheckCircleIcon"
                        : "AlertTriangleIcon",
                  },
                }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("subscription_plan.selection_total", {
                        offered: _vm.offeredTotal,
                        required: _vm.required,
                        period: (
                          _vm.plan.quota_period_label || ""
                        ).toLowerCase(),
                      })
                    ) +
                    " "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex flex-row justify-between items-center mt-2" },
        [
          _vm.lastPage > 1
            ? _c("b-pagination", {
                staticClass: "mb-0",
                attrs: {
                  "total-rows": _vm.total,
                  "per-page": _vm.perPage,
                  size: "sm",
                },
                on: {
                  input: function ($event) {
                    return _vm.reload(false)
                  },
                },
                model: {
                  value: _vm.page,
                  callback: function ($$v) {
                    _vm.page = $$v
                  },
                  expression: "page",
                },
              })
            : _c("div"),
          _c(
            "b-button",
            {
              attrs: {
                variant: "primary",
                disabled: _vm.selected.length === 0,
              },
              on: { click: _vm.addLessons },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("subscription_plan.add_selected_lessons", {
                      count: _vm.selected.length,
                    })
                  ) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }